<template>
  <div v-if="show" :class="spinnerClasses">
    <div
      class="spinner-grow text-primary m-auto"
      :style="spinnerStyle"
      role="status"
    >
      <!-- <span class="sr-only">Loading...</span> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "SpinnerCircle",
  props: {
    show: { type: Boolean, default: false },
    spinnerStyle: { type: String, default: "width: 3rem; height: 3rem;" },
    spinnerClasses: { type: String, default: "text-center m-5" },
  },
};
</script>
